import script from "./EntryPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./EntryPassword.vue?vue&type=script&setup=true&lang=ts"

import "./EntryPassword.vue?vue&type=style&index=0&id=3596b02e&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3596b02e"]])

export default __exports__